import React, { useEffect, useMemo, useState } from "react";
import { getConfig } from "../../../../../../network/auth";
import axios from "axios";
import { baseUrl } from "../../../../../../network/constants/constants";
import { Col, Row, Spinner } from "react-bootstrap";
import WorkerCancelTable from "./workerCancelTable/tableComponent";
import SearchField from "../../../../../customComponent/searchField/searchField";

const WorkerCancelAlert = () => {
  const [loading, setLoading] = useState(false);
  const [workerCancelList, setWorkerCancelList] = useState([]);

  
    const [searchValue, setSearchValue] = useState("");
  
    const handleSearchChange = (event) => {
      setSearchValue(event.target.value);
    };
  
    const filteredWorker = workerCancelList.filter((cancelled) =>
      Object.entries(cancelled).some(([key, value]) => {
        if (Array.isArray(value)) {
          return value.some((item) =>
            item.toString().toLowerCase().includes(searchValue.toLowerCase())
          );
        }
    
        if (typeof value === "boolean") {
          
          const stringValue =
            key === "is_refund_processed"
              ? value
                ? "Refunded"
                : "Not Refunded"
              : "";
    
          return stringValue.toLowerCase().includes(searchValue.toLowerCase());
        }
    
        return (
          value &&
          value.toString().toLowerCase().includes(searchValue.toLowerCase())
        );
      })
    );
    
    
    const displayWorker = searchValue ? filteredWorker : workerCancelList;

    const alertwithIndex = displayWorker.map((alert, index) => ({
      ...alert,
      displayIndex: index + 1,
    }));

  const config = useMemo(() => {
    return getConfig();
  }, []);

  const fetchWorkerAlerts = () => {
    setLoading(true);
    axios
      .get(baseUrl + `superadmin/booking-cancelled-alerts-by-worker/`, config)
      .then((response) => {
        setWorkerCancelList(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Worker Cancelled Alert Error:", error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchWorkerAlerts();
  }, []);
  return (
    <>
      {loading ? (
        <div className="loader-container">
          <Spinner className="spinner-loader" />
        </div>
      ) : (
        <>
          <Row className="mb-2">
            <Col>
            <SearchField searchValue={searchValue} handleSearchChange={handleSearchChange}/>
            </Col>
          </Row>
          <Row>
            <WorkerCancelTable workerCancelList={alertwithIndex} />
          </Row>
        </>
      )}
    </>
  );
};

export default WorkerCancelAlert;
